import { render, staticRenderFns } from "./LoadError.vue?vue&type=template&id=06696a84&"
import script from "./LoadError.vue?vue&type=script&lang=js&"
export * from "./LoadError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports